

function SuccessMsg({ close, msg }) {

    return (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen bg-black opacity-40"></div>
            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 w-1/4 h-2/6 rounded-lg px-10 py-10 flex flex-col justify-between items-center">
                <img src="/image/icon/checkSuccess.png" className="w-20" />
                <p className="text-xl font-bold text-greenCustom-500">با موفقیت</p>
                <p className="rtol">{msg}</p>
                <button className="bg-greenCustom-500 text-white font-bold w-full py-2 rounded" onClick={() => close("")} >ادامه</button>
            </div>
        </>
    )
}
export default SuccessMsg;
